import { render, staticRenderFns } from "./FormActs.vue?vue&type=template&id=e3148c8e&"
import script from "./FormActs.vue?vue&type=script&lang=js&"
export * from "./FormActs.vue?vue&type=script&lang=js&"
import style0 from "./FormActs.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports